import { render, staticRenderFns } from "./SendJoinInvitesCollector.vue?vue&type=template&id=e25d20bc&scoped=true"
import script from "./SendJoinInvitesCollector.vue?vue&type=script&lang=js"
export * from "./SendJoinInvitesCollector.vue?vue&type=script&lang=js"
import style0 from "./SendJoinInvitesCollector.vue?vue&type=style&index=0&id=e25d20bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25d20bc",
  null
  
)

export default component.exports